import { render } from "./ModalCargaArchivos.vue?vue&type=template&id=5d46d9c7&scoped=true"
import script from "./ModalCargaArchivos.vue?vue&type=script&lang=js"
export * from "./ModalCargaArchivos.vue?vue&type=script&lang=js"

import "./ModalCargaArchivos.vue?vue&type=style&index=0&id=5d46d9c7&lang=scss&scoped=true"

import exportComponent from "/Users/maguilar/Dev/repos/garantias-transelec/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d46d9c7"]])

export default __exports__